// removed by extract-text-webpack-plugin
module.exports = {"firstCol":"index__firstCol___2m0sj","lastCol":"index__lastCol___1wqMs","row":"index__row___2acMl","mainCol":"index__mainCol___2_45P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/FilterCriteria__REFACTORED/index.less
// module id = 1896
// module chunks = 3